import { ChangeEvent, useEffect, useRef } from 'react'
import { CommunityDetailInfo } from './communityDetailInfo'
import { BoardListItem, TInput, withDrawnCumtomer } from '../../boardItem'

interface DetailContentsProps {
  isDisabled: boolean
  boardDetail: BoardListItem | null
  height: string
  handleChange: (e: React.ChangeEvent<TInput>) => void
  isGuest: boolean
  scrollToComment: () => void
  handleCopy: () => void
}

export const CommunityDetailContents: React.FC<DetailContentsProps> = ({
  isDisabled,
  boardDetail,
  height,
  handleChange,
  isGuest,
  scrollToComment,
  handleCopy,
}) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null)

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto' // 높이 초기화
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px` // 새로운 높이 설정
    }
  }, [boardDetail?.nttCn]) // boardDetail.NTT_CN이 변경될 때마다 실행

  const handleInputChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    const textarea = e.target
    textarea.style.height = 'auto' // 높이 초기화
    textarea.style.height = `${textarea.scrollHeight}px` // 새로운 높이 설정
    handleChange(e) // 부모 컴포넌트의 handleChange 호출
  }

  return (
    <>
      <div
        style={{
          fontSize: '20px',
          fontWeight: '600',
          whiteSpace: 'pre-wrap', // 자동 줄바꿈
          wordWrap: 'break-word', // 긴 단어 줄바꿈
          overflow: 'hidden',
          marginBottom: '5px',
          marginTop: '5px',
        }}
      >
        {boardDetail?.nttSj}
      </div>
      <CommunityDetailInfo
        isGuest={isGuest}
        boardDetail={boardDetail}
        scrollToComment={scrollToComment}
        handleCopy={handleCopy}
      />
      <div
        style={{
          boxShadow: '0 0 0 0.5px #ebecef',
          borderColor: '#ebecef',
          marginTop: '10px',
          marginBottom: '10px',
        }}
      />
      <div
        style={{
          marginBottom: '10px',
          border: 'none',
          borderRadius: '4px',
          padding: '20px 0',
        }}
      >
        <textarea
          ref={textareaRef}
          id="nttCn"
          name="nttCn"
          value={
            boardDetail?.withDrawYn === 'Y'
              ? withDrawnCumtomer.contents
              : boardDetail?.nttCn
          }
          onChange={handleInputChange}
          style={{
            width: '100%',
            height: '400px',
            border: 'none', // 테두리 제거
            outline: 'none', // 포커스 시 테두리 제거
            borderRadius: '4px', // 모서리를 둥글게
            resize: 'none', // 사용자가 크기 조정 불가
            backgroundColor: 'transparent',
          }}
        >
          {boardDetail?.withDrawYn === 'Y'
            ? withDrawnCumtomer.contents
            : boardDetail?.nttCn}
        </textarea>
      </div>
    </>
  )
}
